import { OpenFeature } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';

/**
 * Killswitch for APP-8800's forced-logout suppression while a desktop
 * recording timer is running. OFF (default): suppression is active — a 401
 * during recording does not clear the Auth0 session. ON: break-glass — revert
 * to legacy behavior (401 always triggers debouncedExpiryLogout). Non-hook
 * only because scribeHttpErrorHandler runs outside React.
 */
export const isRecordingExpiryLogoutSuppressionKilled = () => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'op-scribe-disable-recording-expiry-logout-suppression',
    false
  );
};
